<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter une catégorie</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier une catégorie</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-6">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-6">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            </mat-form-field>
        </div>
       
        <div class="col-sm-6">
          <app-autocomplete-with-code-form   
            name="codeTva" [parent]="form"  
            libelle="Tva" 
            [objets]="this.data.tvas" 
            [(objet)]="tva">
            </app-autocomplete-with-code-form>
        </div>

        <div class="col-sm-6">
          <mat-form-field class="full-width">
            <mat-label>Seuil de tolérence</mat-label>
            <input matInput type="number" formControlName="seuil" lang="fr" max="25" min="0">
            <mat-icon matSuffix  matTooltip="entre 0 et 25 et maximum 2 décimales" style="color: gray !important; font-size: 14px !important;">info
            </mat-icon>
            <mat-error *ngIf="form.get('seuil').hasError('max') || form.get('seuil').hasError('min')">
              Veuillez saisir un seuil entre 0 et 25
            </mat-error>
          </mat-form-field>    
        </div>

        <div class="col-sm-6">
          <div class="full-width">
            <mat-label>Bons de commande avec enveloppe</mat-label>
            <mat-checkbox formControlName="creaEnveloppe">
              <mat-icon matSuffix  matTooltip="Possibilité de créer des bons de commandes enveloppes avec cette catégorie" style="color: gray !important; font-size: 14px !important;">info
              </mat-icon>
            </mat-checkbox>
          </div>    
        </div>

    </form>
  </div>
  
  <div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
  </div>

